import { render } from "./FollowUpWish.vue?vue&type=template&id=50582ba7&scoped=true"
import script from "./FollowUpWish.vue?vue&type=script&lang=js"
export * from "./FollowUpWish.vue?vue&type=script&lang=js"

import "./FollowUpWish.vue?vue&type=style&index=0&id=50582ba7&scoped=true&lang=css"

import exportComponent from "D:\\eazyc\\ezDev\\ECS-Cognitive\\cognitive-screening-mobile-app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50582ba7"]])

export default __exports__